<template>
  <article class="real-estate">
    <!-- message弹窗 -->
    <Message :type="message.type" :title="message.title" :content="message.content" :show.sync="message.show" />
    <Banner :showForm="!showScrollForm" :list="banner.list" @msg="handleShowMsg" :landingPageName="landingPageName" />
    <PainPoint :title="painPoint.title" :list="painPoint.list" />
    <Service :title="service.title" :list="service.list" />
    <Select />
    <Customer />
    <Footer />
    <Stay :show="stayShow" />
  </article>
</template>

<script>
export default {
  components: {
    Banner: () => import('./components/Banner.vue'),
    PainPoint: () => import('./components/PainPoint.vue'),
    Service: () => import('./components/Service.vue'),
    Select: () => import('./components/Select.vue'),
    Customer: () => import('./components/Customer.vue'),
    Footer: () => import('./components/Footer.vue'),
    Stay: () => import('./components/Stay.vue'),
    Message: () => import('../../views/common/components/pc/Message.vue'),
  },
  data() {
    return {
      landingPageName: 'esignPropagate',
      showScrollForm: false,
      stayShow: false,
      banner: {
        list: [
          ['18年+', '服务经验'],
          ['502万+', '企业用户'],
          ['2.7亿+', '个人用户'],
          ['121亿+', '总签章量'],
          ['24x365小时', '管家式服务'],
        ],
      },
      message: {
        type: '',
        title: '',
        content: '',
        show: false,
      },
      painPoint: {
        title: '合同签署之痛',
        list: [
          {
            icon: require('@/assets/images/real-estate/pain-1.svg'),
            title: '印章多 风险高',
            txt: '区域公司和项目公司产生大量印章，导致线下对公章权限管理较被动，分配和调度较困难。',
          },
          {
            icon: require('@/assets/images/real-estate/pain-2.svg'),
            title: '异地多 效率低',
            txt: '分公司遍布全国各地，大量文件通过邮寄方式完成签署，导致签署时效慢且成本高。',
          },
          {
            icon: require('@/assets/images/real-estate/pain-3.svg'),
            title: '类别杂 管理难',
            txt: '人事、采购、财务等相关协议、文件等门类繁多，保存归档及快速调阅成为较大负担。',
          },
          {
            icon: require('@/assets/images/real-estate/pain-4.svg'),
            title: '文件多 审阅难',
            txt: '房地产行业签署文件量庞大，需消耗大量时间和人力进行审阅操作，周期甚至长达数月。',
          },
        ],
      },
      service: {
        title: '提供一站式服务',
        list: [
          {
            img: require('@/assets/images/real-estate/service-1.png'),
            title: '灵活开放集成',
            des: 'e签宝提供了丰富的API接口，开发者可以通过开放平台灵活选择更适合自己业务场景的产品，并将接口能力集成到自己的业务系统中。',
          },
          {
            img: require('@/assets/images/real-estate/service-2.png'),
            title: '高效在线签署',
            des: '优秀的签约体验，满足多终端，多场景签约需求，多种签约方式。帮助地产行业企业的签署平均时长由21天降至5天，签署效率提升76%。',
          },
          {
            img: require('@/assets/images/real-estate/service-3.png'),
            title: '便捷统一管理',
            des: '适应集团化集中管理模式，支持对接多个业务系统，并根据不同业务场景的签署需求，进行差异化的参数配置。',
          },
        ],
      },
    }
  },
  mounted() {
    window.addEventListener('scroll', this.scrollHandle, true)
  },
  methods: {
    scrollHandle() {
      const sh = document.body.clientHeight
      const h = document.querySelector('#app').clientHeight - sh
      const fh = document.querySelector('.footer').clientHeight
      const bh = document.querySelector('.banner').clientHeight
      //   console.log(`滚动高度-${h}`, `页面高度-${sh}`)
      //   console.log(`banner高度-${bh}`, `底部高度-${fh}`)
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop // 滚动条偏移量
      this.stayShow = scrollTop >= bh && scrollTop < h - fh
      this.showScrollForm = scrollTop >= window.screen.height
    },
    handleShowMsg({ type, title, content }) {
      this.message.type = type
      this.message.title = title
      this.message.content = content
      this.message.show = true
    },
  },
}
</script>

<style lang="less" scoped>
.real-estate {
  min-width: 1180px;
}
</style>
